const ToastGetter = {
    toast: (state) => state.toast
};

export default ToastGetter;